import React from 'react';
import { Button, Label } from 'govuk-react-jsx';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getInstallerDetails } from '../../features/application/applicationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getSelectedLandlordClient } from '../../features/pmc/pmcJourneySlice';
import useTitle from '../../hooks/useTitle';

const InstallerConfirm = () => {
  const history = useHistory();

  const handleBtnClick = () => {
    history.push('/pmcApp/installation-address');
  };

  const installerDetailsRedux = useSelector(getInstallerDetails);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const currentUserData = useSelector(getSelectedLandlordClient);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcApp.InstallerConfirm.s7',
    'Confirm this is your installer - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const pageModel = (
    <>
      <div className="govuk-form-group">
        <span className="govuk-caption-l">
          {currentUserData != null &&
            currentUserData.landlord_account_name != null &&
            currentUserData.landlord_account_name}
        </span>
        <Label
          className="govuk-label--xl govuk-!-padding-bottom-7"
          isPageHeading
        >
          {copyProvider.getCopy(
            'pmcApp.InstallerConfirm.s1',
            'Confirm this is your installer'
          )}
        </Label>
        <h2 className="govuk-heading-s">
          {copyProvider.getCopy(
            'pmcApp.InstallerConfirm.s2',
            "Installer's OZEV number"
          )}
        </h2>
        <p className="govuk-body govuk-!-font-size-19">
          {installerDetailsRedux &&
            installerDetailsRedux?.installerDetails?.installer_number}
        </p>
        <h2 className="govuk-heading-s">
          {copyProvider.getCopy('pmcApp.InstallerConfirm.s3', 'Installer name')}
        </h2>
        <p className="govuk-body govuk-!-font-size-19">
          {installerDetailsRedux &&
            installerDetailsRedux?.installerDetails?.company_name}
        </p>
        <Link
          className="govuk-link govuk-body govuk-!-font-size-19"
          to="/pmcApp/installer-details"
        >
          {copyProvider.getCopy(
            'pmcApp.InstallerConfirm.s5',
            'This is not my installer'
          )}
        </Link>
      </div>
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'pmcApp.InstallerConfirm.s6',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default InstallerConfirm;
